import React, { Component } from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import './HeaderData.scss';

class HeaderData extends Component {
  static propTypes = {
    className: string,
    label: string,
    value: string
  };

  static defaulProps = {
    className: 'pxl-text-small'
  };

  render() {
    const { className, label, value } = this.props;
    const dataPointClass = classnames({
      matches__section: true,
      [className]: className
    });
    return (
      <div className={dataPointClass}>
        {label}
        <span className="matches__data-item">{value}</span>
      </div>
    );
  }
}

export default HeaderData;
